export const isLoading = (state) => state.branch.isLoading
export const isSuccess = (state) => state.branch.isSuccess
export const branchName = (state) => state.branch.branchName
